module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "view-transactions-detail"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-form",
    staticStyle: {
      "max-width": "700px",
      "margin": "16px auto"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('h3', {
    staticClass: "trx-title"
  }, [_vm._v(_vm._s(_vm.form.trxId))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.t1')))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "border-line sl-trx-val",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.trxId')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.trxId))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.createTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.createTime))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.createLocalTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.localTime))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.customer')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.customer))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.payChannel')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.payType))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.payTrxId')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.businessId))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.posId')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.sn))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.cashier')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.username))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.customer')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.username))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(!_vm.editRemark) ? _c('div', {
    staticClass: "sl-remark"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.remark')) + ":")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "relative",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.editRemark = true;
        _vm.remarkCnt = _vm.form.remark;
        _vm.remarkNumber = 200 - _vm.form.remark.length
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.form.remark))]), _c('i')])]) : _c('div', {
    staticClass: "sl-remark-edit"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.remark')) + ":")]), _vm._v(" "), _c('div', [_c('el-input', {
    attrs: {
      "maxlength": 200,
      "type": "textarea",
      "autosize": {
        minRows: 1,
        maxRows: 5
      },
      "placeholder": "remark"
    },
    on: {
      "change": _vm.handleRemarkChange
    },
    model: {
      value: (_vm.remarkCnt),
      callback: function($$v) {
        _vm.remarkCnt = $$v
      },
      expression: "remarkCnt"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sl-remark-number"
  }, [_vm._v(_vm._s(_vm.remarkNumber))]), _vm._v(" "), _c('div', {
    staticClass: "sl-remark-action"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.editRemark = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "success",
      "loading": _vm.saveRemarkLoading
    },
    on: {
      "click": _vm.saveRemark
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.save')))])], 1)], 1)])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "border-line sl-trx-val",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    class: {
      'sl-no-coupon': _vm.form.disAmount === '0.00' || _vm.form.disAmount === ''
    },
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('img', {
    staticClass: "sl-line-01",
    attrs: {
      "src": require("../../assets/imgs/line_01.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sl-trx-mainval"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.realAmount')) + ":")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v(_vm._s(_vm.form.realAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "sl-trx-subval"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/line_02.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.customerAmount')) + ":")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v(_vm._s(_vm.form.initAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "sl-trx-subval sl-trx-discount"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/line_02.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.discount')) + ":")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v("-" + _vm._s(_vm.form.disAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "sl-trx-subval"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/line_02.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.fee')) + ":")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v(_vm._s(_vm.form.serviceFee))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.cRate')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s((_vm.form.cRate * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.mRate')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s((_vm.form.merchantFeeRate * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.settleAmount')) + ":")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v(_vm._s(_vm.form.settleAmount))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.transferName))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "border-line sl-trx-val",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.settleTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.settleTime))])])])], 1), _vm._v(" "), (_vm.form.refundList.length !== 0) ? [_vm._l((_vm.form.refundList), function(item, index) {
    return [_c('el-row', {
      staticClass: "sl-trx-val",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refundRecord')))])])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refundStatus')) + ":")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status === '10'),
        expression: "item.status === '10'"
      }]
    }, [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.requestForRefund')))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status === '11'),
        expression: "item.status === '11'"
      }]
    }, [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refunded')))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status === '12'),
        expression: "item.status === '12'"
      }]
    }, [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refundFailed')))])])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.appTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.createTime))])])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.completeTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.modifyTime))])])])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "sl-trx-val",
      class: {
        'border-inline': index + 1 !== _vm.form.refundList.length
      },
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refundAmount')) + ":")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v(_vm._s(item.refundAmount))])])])], 1)]
  })] : _vm._e(), _vm._v(" "), _c('el-row', {
    class: {
      'border-top': _vm.form.refundList.length !== 0
    },
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refund')))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "sl-trx-val",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refundAbleAmount')) + ":")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v(_vm._s(_vm.form.refundAmount))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refundAmount')) + ":")]), _vm._v(" "), _c('el-input', {
    staticClass: "sl-fr sl-val-input",
    class: {
      'disabled': _vm.show
    },
    attrs: {
      "type": "number",
      "disabled": _vm.show,
      "step": "0.01",
      "auto-complete": "off",
      "min": "0"
    },
    on: {
      "focus": function($event) {
        _vm.type = 'text'
      },
      "blur": function($event) {
        _vm.type = 'password'
      }
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  }), _vm._v(" "), _c('b', {
    staticClass: "sl-fr"
  }, [_vm._v(_vm._s(_vm.currency))]), _vm._v(" "), _c('el-checkbox', {
    staticClass: "sl-fr sl-checkbox",
    attrs: {
      "disabled": _vm.allDistable
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Functional.all', 0)))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.finalAmount')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "final-amount"
  }, [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v(_vm._s(_vm.finalAmount))])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Transactions'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', 'Back', 'View transaction detail')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.back')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.amount !== 0),
      expression: "form.amount !== 0"
    }],
    attrs: {
      "disabled": _vm.refundShow
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogVisible = true;
        _vm.$ga.event('Button', 'Refund', 'View transaction detail')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Button.refund')))])], 1)], 1)], 2)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('Views.TrxViewDeital.tips.title'),
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.tips.cnt')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-input', {
    staticClass: "refund-pwd",
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.$t('Views.TrxViewDeital.tips.placeholder'),
      "auto-complete": "off"
    },
    model: {
      value: (_vm.refundPwd),
      callback: function($$v) {
        _vm.refundPwd = $$v
      },
      expression: "refundPwd"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.refund
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.confirm')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-319b0e42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/transactions/view-detail.vue
// module id = 1094
// module chunks = 1